import {onlineAppRootLoader} from '../../rankers/online_apps/components/online_app_root/online_app_root_loader';
onlineAppRootLoader();

import {suppressNativeLongPressMenus} from '../../rankers/lib/long_press_menu_suppressor';
suppressNativeLongPressMenus();

import {enableInstantActiveStates} from '../../rankers/lib/instant_active_states';
enableInstantActiveStates();

import {hideFailedImages} from '../../rankers/lib/hide_failed_images';
hideFailedImages();

// The map submarker's hero image upgrades from its inlined placeholder to the full-res image.
// The submarker markup is fetched and injected at runtime, so the loader has to be in this pack
// (the map page's) as well as the experience pack that serves the native apps' submarker page.
import {progressiveImageLoader} from '../../rankers/components/progressive_image/progressive_image_loader';
progressiveImageLoader();

// The onboarding overlay host. It fetches the carousel (and the carousel's own bundle) only when
// the traveller hasn't seen this content version — so for everyone else this loader is the entire
// cost of the onboarding feature.
import {onlineAppOnboardingLoader} from '../../rankers/online_apps/onboarding/online_app_onboarding_loader';
onlineAppOnboardingLoader();

document.dispatchEvent( new Event('OnlineAppLoaded') );